import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import ContactUsComponent from "../components/contactUs";
import Footer from "../components/footer/Footer";
import Head from "next/head";
import Layout from "../components/sidebarPro";
import useTranslation from "next-translate/useTranslation";

var ContactUs = function ContactUs() {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var isRTL = lang === 'farsi';
  return /*#__PURE__*/_jsxs(Layout, {
    children: [/*#__PURE__*/_jsxs(Head, {
      children: [/*#__PURE__*/_jsx("title", {
        children: isRTL ? "تماس با ما - دنیای واژگان" : "Contact Us - wow kanoon"
      }), /*#__PURE__*/_jsx("link", {
        rel: "icon",
        href: "/images/logos/favicon.png"
      })]
    }), /*#__PURE__*/_jsx(ContactUsComponent, {}), /*#__PURE__*/_jsx(Footer, {
      hasBackToTop: true
    })]
  });
};

export var __N_SSG = true;
export default ContactUs;